import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { API_QUERY_KEYS, QueryDefaults, getParentOrganisations } from 'api';
import {
  manageOrganisationsPaginationState,
  organisationsRequestState,
  manageOrganisationsPageNumberState,
} from 'store';
import { GetParentOrganisationsResponse } from 'types';

export const useParentOrganisations = (): UseQueryResult<GetParentOrganisationsResponse> => {
  const request = useRecoilValue(organisationsRequestState);
  const setPageNumber = useSetRecoilState(manageOrganisationsPageNumberState);
  const setManageOrganisationsPagination = useSetRecoilState(
    manageOrganisationsPaginationState
  );

  return useQuery(
    [API_QUERY_KEYS.getParentOrganisations, request],
    () => getParentOrganisations(request),
    {
      ...QueryDefaults,
      onSuccess: (data: GetParentOrganisationsResponse) => {
        if (
          data?.paginationInfo?.totalCount > 0 &&
          data?.parentOrganisations.items.length === 0
        ) {
          setPageNumber(1);
        }
        setManageOrganisationsPagination(data.paginationInfo);
      },
    }
  );
};
